class SearchPopup extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.popupWrapper = this.querySelector("#top-search-wrapper");
    this.overlay = this.querySelector(".search-popup__overlay");
    this.searchInput = this.querySelector("input[type='search']");
    this.popupBody = this.querySelector(".search-popup__body");
    this.searchInputClearIconWrapper = this.querySelector(
      ".search-popup__form--icons"
    );
    this.searchInputClearIcon = this.querySelector(
      ".search-popup__input-clear"
    );

    //? input events
    this.searchInput.addEventListener(
      "input",
      this.debounce((event) => {
        this.onChangeSearchInput(event);
      }, 300).bind(this)
    );

    //? event listeners
    document.addEventListener("click", this.handleDocumentClick.bind(this));
  }

  handleDocumentClick(event) {
    if (event.target.closest(".search-show")) {
      this.popupWrapper.classList.add("show");
      document.documentElement.style.overflow = "hidden";
      this?.searchInput?.focus();
      return;
    }

    //? close popup on click outside
    if (event.target.closest(".search-popup__overlay") === this.overlay) {
      this.popupWrapper.classList.remove("show");
      document.documentElement.style.overflow = "auto";
      this.searchInput.value = "";
      this.hideSearchInputClear();
      this.hidePopupBody();
      return;
    }

    //? close popup on click close icon
    if (event.target.closest(".search-popup__close")) {
      this.popupWrapper.classList.remove("show");
      document.documentElement.style.overflow = "auto";
      this.searchInput.value = "";
      this.hideSearchInputClear();
      this.hidePopupBody();
      return;
    }

    //? clear input
    if (event.target.closest(".search-popup__input-clear")) {
      this.searchInput.value = "";
      this.hideSearchInputClear();
      this.hidePopupBody();
    }

    return;
  }

  onChangeSearchInput() {
    const searchTerm = this.searchInput.value.trim();

    if (!searchTerm.length) {
      this.hideSearchInputClear();
      this.hidePopupBody();
      return;
    }

    this.showSearchInputClear();
    this.getSearchResults(searchTerm);
  }

  showSearchInputClear() {
    this.searchInputClearIconWrapper.classList.remove("hide");
    this.searchInputClearIconWrapper.classList.add("show");
  }
  hideSearchInputClear() {
    this.searchInputClearIconWrapper.classList.remove("show");
    this.searchInputClearIconWrapper.classList.add("hide");
  }

  getSearchResults(searchTerm) {
    fetch(`/search/suggest?q=${searchTerm}&section_id=predictive-search-popup`)
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }
        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser()
          .parseFromString(text, "text/html")
          .querySelector("#shopify-section-predictive-search-popup").innerHTML;
        this.popupBody.innerHTML = resultsMarkup;
        this.showPopupBody();
      })
      .catch((error) => {
        this.hidePopupBody();
        throw error;
      });
  }

  showPopupBody() {
    if (this.popupBody.innerHTML.trim()) {
      this.popupBody.style.display = "block";
    }
  }

  hidePopupBody() {
    this.popupBody.innerHTML = "";
    this.popupBody.style.display = "none";
  }

  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}

customElements.define("search-popup", SearchPopup);
